import {
    IBannerTemplate, IBannerTemplatesFilter,
} from "./types";
import {AtLeastOne, IdObjectsWithId} from "../../../utils";
import {defaultActive} from "./defaults";
import {VariablesType} from "../variables/types";
import {createAction, createAsyncAction} from "typesafe-actions";

export const fetchBannerTemplatesAsyncActions = createAsyncAction(
    'FETCH_BANNER_TEMPLATES_REQUEST',
    'FETCH_BANNER_TEMPLATES_SUCCESS',
    'FETCH_BANNER_TEMPLATES_FAILURE'
)<{}, { bannerTemplates: IdObjectsWithId<IBannerTemplate> }, { error: Error }>();

export const fetchBannerTemplateByIdAsyncActions = createAsyncAction(
    'FETCH_BANNER_TEMPLATE_BY_ID_REQUEST',
    'FETCH_BANNER_TEMPLATE_BY_ID_SUCCESS',
    'FETCH_BANNER_TEMPLATE_BY_ID_FAILURE'
)<{ id: string }, { bannerTemplate: IBannerTemplate, masterBannerTemplate?: IBannerTemplate }, { error: Error }>();

export const saveBannerTemplateAsyncActions = createAsyncAction(
    'SAVE_BANNER_TEMPLATE_REQUEST',
    'SAVE_BANNER_TEMPLATE_SUCCESS',
    'SAVE_BANNER_TEMPLATE_FAILURE'
)<{ bannerTemplate: AtLeastOne<IBannerTemplate, { id: { id: string } }> }, { bannerTemplate: IBannerTemplate }, { error: Error }>();

export const deleteBannerTemplateAsyncActions = createAsyncAction(
    'DELETE_BANNER_TEMPLATE_REQUEST',
    'DELETE_BANNER_TEMPLATE_SUCCESS',
    'DELETE_BANNER_TEMPLATE_FAILURE'
)<{ id: string }, { id: string }, { error: Error }>();

export const linkBannerVariablesIdAsyncAction = createAsyncAction(
    'LINK_BANNER_VARIABLES_ID_REQUEST',
    'LINK_BANNER_VARIABLES_ID_SUCCESS',
    'LINK_BANNER_VARIABLES_ID_FAILURE'
)<{
    bannerTemplateId: string,
    bannerVariablesId: string,
    variablesType: VariablesType
}, {
    bannerTemplateId: string,
    bannerVariablesId: string
}, { error: Error }>();

export interface IModifyingActiveBannerTemplateActionPayload {
    bannerTemplate: Partial<IBannerTemplate>;
}
export const modifyingActiveBannerTemplateAction = createAction('MODIFYING_ACTIVE_BANNER_TEMPLATE', action => {
    return (params: IModifyingActiveBannerTemplateActionPayload) => action(params);
});

export interface IToggleBannerTemplatesFilterActionPayload {
    filter: Partial<IBannerTemplatesFilter>;
}

export const toggleBannerTemplatesFilterAction = createAction('TOGGLE_BANNER_TEMPLATES_FILTER', action => {
    return (params: IToggleBannerTemplatesFilterActionPayload) => action(params);
});


export interface IAddingNewBannerTemplateActionPayload {
    template: IBannerTemplate
}
export const addingNewBannerTemplateAction = createAction('ADDING_NEW_BANNER_TEMPLATE', action => {
    return (params: IAddingNewBannerTemplateActionPayload = {template: defaultActive}) => action(params);
});

export interface ISetMasterActiveBannerTemplateByIdActionPayload {
    id: string;
}

export const setMasterActiveBannerTemplateByIdAction = createAction('SET_MASTER_ACTIVE_BANNER_TEMPLATE_BY_ID', action => {
    return (params: ISetMasterActiveBannerTemplateByIdActionPayload) => action(params);
});
